// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1Li2f","rowsWrapper":"style_rowsWrapper__1r5Pp","rowWrapper":"style_rowWrapper__3bO3H"};